import { useEffect, useMemo, useState } from 'react';
import styles from './sidebar.module.scss';
import { SidebarBranchesProps } from '../../../../interfaces/components';
import { useDebounce, useToast } from '../../../../helpers/hooks';
import ButtonShared from '../../../../components/Button/Button';
import SidebarShared from '../../../../components/Sidebar/Sidebar';
import TextFieldShared from '../../../../components/TextField/TextField';
import PhoneInput from '../../../../components/PhoneInput/PhoneInput';
import SelectShared from '../../../../components/Select/Select';
import { formatRut, validateRut } from '../../../../helpers/app';

const Sidebar = ({
    user,
    state,
    setState,
    branchSelected,
    getBranches,
    branches,
    addBranch,
    cleanAddBranch,
    editBranch,
    cleanEditBranch,
    getRegions,
    regions,
    getCities,
    cities,
    getCommunes,
    communes
}: SidebarBranchesProps) => {
    const toast = useToast();
    const [nameBranch, setNameBranch] = useState<any>({value: "", error: ""});
    const [directionBranch, setDirectionBranch] = useState<any>({value: "", error: ""});
    const [nameContact, setNameContact] = useState<any>({value: "", error: ""});
    const [lastNameContact, setLastNameContact] = useState<any>({value: "", error: ""});
    const [email, setEmail] = useState<any>({value: "", error: ""});
    const [rutContact, setRutContact] = useState<any>({value: "", error: ""});
    const [phoneValue, setPhoneValue] = useState<any>({code: "", number: "", error: ""});
    const [regionSelected, setRegionSelected] = useState<any>({value: "", error: ""});
    const [citySelected, setCitySelected] = useState<any>({value: "", error: ""});
    const [communeSelected, setCommuneSelected] = useState<any>({value: "", error: ""});

    const handleChangePhone = (value: any, type: string) => {
        if(type === "code"){
            setPhoneValue({...phoneValue, code: value});
        }else{
            setPhoneValue({...phoneValue, number: value});
        }
    }

    const handleChangeRut = (value: any) => {
        const formatValue = formatRut(value);
        if(!validateRut(formatValue)){
            return setRutContact({value: formatValue, error: "Ingresa un rut válido"});
        }
        setRutContact({value: formatValue, error: ""});
    }

    const handleChangeRegion = (id: string) => {
        const region = regions.data.find(({ region_id }: any) => region_id === id);
        setRegionSelected({...regionSelected, value: {id: region?.region_id, name: region?.name}});
        getCities(id);
        setCitySelected({...citySelected, value: ""});
        setCommuneSelected({...communeSelected, value: ""});
    }

    const handleChangeCity = (id: string) => {
        const city = cities.data.find(({ city_id }: any) => city_id === id);
        setCitySelected({...citySelected, value: {id: city?.city_id, name: city?.name}});
        getCommunes(id);
        setCommuneSelected({...communeSelected, value: ""});
    }

    const handleChangeCommune = (id: string) => {
        const commune = communes.data.find(({ commune_id }: any) => commune_id === id);
        setCommuneSelected({...communeSelected, value: {id: commune?.commune_id, name: commune?.name}});
    }

    const handleCloseSidebar = () => {
        setState({...state, open: false});
    }

    const handleSendInvitation = () => {
        if(!nameBranch?.value) {return setNameBranch({...nameBranch, error: "Debes ingresar una sucursal"})} else setNameBranch({...nameBranch, error: ""});
        if(!directionBranch?.value) {return setDirectionBranch({...directionBranch, error: "Debes ingresar una dirección"})} else setDirectionBranch({...directionBranch, error: ""});
        if(!nameContact?.value) {return setNameContact({...nameContact, error: "Debes ingresar un nombre"})} else setNameContact({...nameContact, error: ""});;
        if(!lastNameContact?.value) {return setLastNameContact({...lastNameContact, error: "Debes ingresar un nombre"})} else setLastNameContact({...lastNameContact, error: ""});;
        if(!rutContact?.value) {return setRutContact({...rutContact, error: "Debes ingresar un RUT"})} else setRutContact({...rutContact, error: ""});
        if(!email?.value) {return setEmail({...email, error: "Debes ingresar un email"})} else setEmail({...email, error: ""});
        if(!phoneValue?.code) {return setPhoneValue({...phoneValue, error: "Debes ingresar un pais"})} else setPhoneValue({...phoneValue, error: ""});
        if(!phoneValue?.number) {return setPhoneValue({...phoneValue, error: "Debes ingresar un telefono"})} else setPhoneValue({...phoneValue, error: ""});
        if(!regionSelected?.value) return setRegionSelected({...regionSelected, error: "Debes seleccionar una región"});

        if(regionSelected?.value) {
            if(!citySelected?.value) {
                setCitySelected({...citySelected, error: "Debes seleccionar una ciudad"});
                if(!communeSelected?.value) return setCommuneSelected({...communeSelected, error: "Debes seleccionar una comuna"});
            }
            if(!communeSelected?.value) return setCommuneSelected({...communeSelected, error: "Debes seleccionar una comuna"});
        }
        
        const phone = {
            code: phoneValue?.code,
            number: phoneValue?.number,
        }

        const bodyRequest = {
            "dealership": user?.dealership,
            "name": nameBranch?.value,
            "address": directionBranch?.value,
            "contact": {
                "name": nameContact?.value,
                "last_name": lastNameContact?.value,
                "email": email?.value,
                "phone": phone,
                "legal_id_type": "rut",
                "legal_id": rutContact?.value,
            },
            "residence": {
                "region_id": regionSelected?.value?.id,
                "region_name": regionSelected?.value?.name,
                "city_id": citySelected?.value?.id,
                "city_name": citySelected?.value?.name,
                "commune_id": communeSelected?.value?.id,
                "commune_name": communeSelected?.value?.name
            }
        };

        if(state.type === "add"){
            addBranch(bodyRequest);
        }
        if(state.type === "edit"){
            editBranch(branchSelected?._id, bodyRequest);
        }
    } 

    const regionsNormalized: any = useMemo(() => {
        return regions.data && regions.data.map((region: any) => (
            {
                id: region.region_id,
                name: region.name
            }
        ))
    }, [regions.data]);

    const citiesNormalized: any = useMemo(() => {
        return cities.data && cities.data.map((city: any) => (
            {
                id: city?.city_id,
                name: city?.name
            }
        ))
    }, [cities.data]);

    const communesNormalized: any = useMemo(() => {
        let data  = [];
        if(citySelected?.value?.id){
            data = communes.data && communes.data.map((commune: any) => (
                {
                    id: commune?.commune_id,
                    name: commune?.name,
                    cityId: commune?.city_id
                }
            ));
        }
        return data;
    }, [communes.data, regionSelected?.value, citySelected?.value]);

    useEffect(() => {
        if(branchSelected?._id){
            if (branchSelected?.residence && branchSelected?.residence.lengtht > 0) {
                getCities(branchSelected?.residence.region_id);
                getCommunes(branchSelected?.residence.city_id);
            }
            setNameBranch({value: branchSelected?.name, error: ""});
            setDirectionBranch({...directionBranch, value: branchSelected?.address});
            setNameContact({value: branchSelected?.contact?.name, error: ""});
            setLastNameContact({value: branchSelected?.contact?.last_name, error: ""});
            setEmail({value: branchSelected?.contact?.email, error: ""});
            setRutContact({value: branchSelected?.contact?.legal_id ?? "", error: ""});
            setPhoneValue({code: branchSelected?.contact?.phone?.code, number: branchSelected?.contact?.phone?.number, error: ""});
            setRegionSelected({value: {...regionSelected?.value, id: branchSelected?.residence?.region_id, name: branchSelected?.residence?.region_name}, error: ""});
            setCitySelected({value: {...citySelected?.value, id: branchSelected?.residence?.city_id, name: branchSelected?.residence?.city_name}, error: ""});
            setCommuneSelected({value: {...communeSelected?.value, id: branchSelected?.residence?.commune_id, name: branchSelected?.residence?.commune_name}, error: ""});
        }else{
            setNameBranch({value: "", error: ""});
            setDirectionBranch({value: "", error: ""});
            setNameContact({value: "", error: ""});
            setLastNameContact({value: "", error: ""});
            setEmail({value: "", error: ""});
            setRutContact({value: "", error: ""});
            setPhoneValue({code: "+56", number: "", error: ""});
            setRegionSelected({value: "", error: ""});
            setCitySelected({value: "", error: ""});
            setCommuneSelected({value: "", error: ""});
        }
    }, [branchSelected]);

    useEffect(() => {
        if(branches?.add?.fetching === "failure"){
            toast("Ha ocurrido un error al añadir una nueva sucursal");
            cleanAddBranch();
        }
        if(branches?.add?.fetching === "success"){
            toast("Sucursal añadida correctamente");
            setState({...state, open: false});
            
            if(user?.profile?.code !== "admin-brand") {
                getBranches(user?.dealership, "branches");
            }
            cleanAddBranch();
        }
    }, [branches?.add?.fetching]);

    useEffect(() => {
        if(branches?.edit?.fetching === "failure"){
            toast("Ha ocurrido un error al editar la sucursal");
            cleanEditBranch();
        }
        if(branches?.edit?.fetching === "success"){
            toast("Sucursal editada correctamente");
            setState({...state, open: false});
           
            if(user?.profile?.code !== "admin-brand") {
                getBranches(user?.dealership, "branches");
            }
            cleanEditBranch();
        }
    }, [branches?.edit?.fetching]);

    useEffect(() => {
        getRegions();
    }, []);

    return (
        <SidebarShared 
            variant="close" 
            open={state?.open} 
            onBack={handleCloseSidebar}
            title={`${state.type === "add" ? "Nueva" : "Editar"} sucursal`} 
            id="branchesSidebarContent"
        >
            <div className={styles.sidebarContent}>
                <TextFieldShared
                    label="Nombre sucursal"
                    name="nameBranch"
                    value={nameBranch?.value}
                    onChange={(value: any) => setNameBranch({...nameBranch, value: value})}
                    error={nameBranch?.error}
                    className={styles.full}
                />
                <TextFieldShared
                    variant="location"
                    label="Dirección"
                    name="directionBranch"
                    value={directionBranch?.value}
                    onChange={({value}: any) => setDirectionBranch({...directionBranch, value: value})}
                    error={directionBranch?.error}
                    className={styles.full}
                />
                <TextFieldShared
                    label="RUT"
                    name="rutContact"
                    value={rutContact?.value}
                    onChange={handleChangeRut}
                    error={rutContact?.error}
                    className={styles.full}
                />
                <SelectShared
                    label="Región"
                    name="region"
                    value={regionSelected?.value && regionSelected?.value?.id}
                    className={styles.full}
                    onChange={handleChangeRegion}
                    options={regionsNormalized}
                    loading={regions?.fetching === "loading"}
                    error={regionSelected?.error && regionSelected?.error}
                />
                <SelectShared
                    label="Ciudad"
                    name="city"
                    value={citySelected?.value && citySelected?.value?.id}
                    className={styles.full}
                    onChange={handleChangeCity}
                    options={citiesNormalized}
                    optionsEmptyMessage="Debes seleccionar una región"
                    loading={cities?.fetching === "loading"}
                    error={citySelected?.error && citySelected?.error}
                />
                <SelectShared
                    label="Comuna"
                    name="commune"
                    value={communeSelected?.value && communeSelected?.value?.id}
                    className={styles.full}
                    onChange={handleChangeCommune}
                    options={communesNormalized}
                    optionsEmptyMessage="Debes seleccionar una ciudad"
                    loading={communes?.fetching === "loading"}
                    error={communeSelected?.error && communeSelected?.error}
                />
                <p className={`${styles.subtitle} ${styles.full}`}>Contacto</p>
                <TextFieldShared
                    label="Nombre"
                    name="nameContact"
                    value={nameContact?.value}
                    onChange={(value: any) => setNameContact({...nameContact, value: value})}
                    error={nameContact?.error}
                    className={styles.half}
                />
                <TextFieldShared
                    label="Apellido"
                    name="lastNameContact"
                    value={lastNameContact?.value}
                    onChange={(value: any) => setLastNameContact({...lastNameContact, value: value})}
                    error={lastNameContact?.error}
                    className={styles.half}
                />
                <TextFieldShared
                    label="Email"
                    name="email"
                    value={email?.value}
                    onChange={(value: any) => setEmail({...email, value: value})}
                    className={styles.full}
                    error={email?.error}
                />
                <PhoneInput
                    label="Telefono"
                    numberValue={phoneValue.number}
                    codeValue={phoneValue.code}
                    onChange={handleChangePhone}
                    error={phoneValue?.error}
                    className={`${styles.full} ${styles.phoneSelector}`}
                />
                <ButtonShared
                    onPress={handleSendInvitation}
                    title={
                        state.type === "add" 
                        ? "Crear sucursal" 
                        : "Guardar cambios" 
                    }
                    className={`${styles.saveButton} ${styles.full}`}
                    primary
                    loading={branches?.add?.fetching === "loading" || branches?.edit?.fetching === "loading"}
                />
            </div>
        </SidebarShared>
    )
};
export default Sidebar;